import { FC, useCallback, useEffect, useState } from 'react'
import styled from 'styled-components'
import { setTawkChatSessionOpen } from './supportChatApi'

/**
 * Backdrop + escape while tawk chat is open (floating launcher or app menu entry).
 */
export const SupportChatSessionOverlay: FC = () => {
  const [ chatOpen, setChatOpen ] = useState(false)

  useEffect(() => {
    const onOpened = () => setChatOpen(true)
    const onClosed = () => setChatOpen(false)
    setChatOpen(document.body.hasAttribute('data-tawk-chat-open'))
    window.addEventListener('tipsterizer-tawk-chat-opened', onOpened)
    window.addEventListener('tipsterizer-tawk-chat-closed', onClosed)
    return () => {
      window.removeEventListener('tipsterizer-tawk-chat-opened', onOpened)
      window.removeEventListener('tipsterizer-tawk-chat-closed', onClosed)
    }
  }, [])

  const onClose = useCallback(() => {
    setTawkChatSessionOpen(false)
    setChatOpen(false)
  }, [])

  useEffect(() => {
    if (!chatOpen) return
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose()
    }
    window.addEventListener('keydown', onKeyDown)
    return () => window.removeEventListener('keydown', onKeyDown)
  }, [ chatOpen, onClose ])

  if (!chatOpen) return null

  return (
    <ChatBackdrop
      type="button"
      aria-label="Close support chat"
      onClick={onClose}
    />
  )
}

const ChatBackdrop = styled.button`
  position: fixed;
  inset: 0;
  z-index: 1000;
  border: none;
  padding: 0;
  margin: 0;
  background: rgba(0, 0, 0, 0.4);
  cursor: default;
`
